/**
 *
 * MentorFormOverview
 *
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Text, { TEXT_SIZE, TEXT_COLOR, TEXT_WEIGHT } from '@components/Text';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import SurveyJsPollRuntime from '@shared/Resources/Poll/Client/SurveyJsPollRuntime';
import { TitleContainer, DescriptionArea } from './styles';

class MentorFormOverview extends PureComponent {
  render() {
    const { resource: { description, surveySchema }, t } = this.props;
    return (
      <div>
        <DescriptionArea>
          <TitleContainer>
            <Text
              size={TEXT_SIZE.H4}
              textColor={TEXT_COLOR.DARK_BLUE}
              weight={TEXT_WEIGHT.BOLD}
            >
              {t('Common.UI.description')}
            </Text>
          </TitleContainer>
          <Text size={TEXT_SIZE.T4} textColor={TEXT_COLOR.DARK_BLUE}>
            {description}
          </Text>
        </DescriptionArea>
        <SurveyJsPollRuntime schema={surveySchema} readOnly />
      </div>
    );
  }
}

MentorFormOverview.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default compose(withTranslation())(MentorFormOverview);
